import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useApolloClient } from '@vue/apollo-composable'
import gql from 'graphql-tag'

export const useMasterdataStore = defineStore('masterdata', () => {
  const { client: apolloClient } = useApolloClient()

  const md = ref({})
  const loaded = ref(false)

  const getMasterdata = () => {
    apolloClient.query({
      query: gql`query {
        titles {
          key
          description
        }
        salutations {
          key
          description
        }
        countries {
          key
          description
          zipCodePattern
        }
      }`
    }).then(({ data }) => {
      Object.entries(data).forEach(([key, value]) => {
        md.value[key] = value ?? []
      })
    }).then(() => {
      loaded.value = true
    })
  }

  const getMasterDataDescription = (type, key) => {
    if (key) {
      let item = null
      if (md.value[type]) {
        item = md.value[type].find(e => e.key === key)
      } else {
        console.error('cannot find master data type [' + type + ']')
      }
      if (item) {
        return item.description
      }
      return key
    }
    return null
  }

  const titles = computed(() => md.value.titles)
  const salutations = computed(() => md.value.salutations)
  const countries = computed(() => md.value.countries)

  return {
    loaded,
    titles,
    salutations,
    countries,
    getMasterdata,
    getMasterData: getMasterdata,
    getMasterDataDescription
  }
})
